const hasSmoothScroll = () => "scrollBehavior" in document.documentElement.style;
export default hasSmoothScroll;
